import Keycloak from "keycloak-js";
const keycloak = new Keycloak({
    url: "https://keycloak.kyu-apps.com/",
    realm: "kyu-solutions",
    clientId: "sokyut-web",
});

export default keycloak;
